import { render, staticRenderFns } from "./importantOperation.vue?vue&type=template&id=20087ce2&scoped=true&"
import script from "./importantOperation.vue?vue&type=script&lang=js&"
export * from "./importantOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20087ce2",
  null
  
)

export default component.exports